export default () => ({
  user: null,
  isInitialized: false,
  listings: [],
  followingUsers: [],
  followingUsersTotals: null,
})
